import React from "react";
import { Row, Col, Form, Select, Input, Button } from "antd";
 
const Search = (props) => {
  const {
    form,
    onSearch=()=>{},
    onAdd=()=>{}
  } = props;
 
  const handleSubmit = () => {
    form.validateFields((err, values) => {
      if (!err) { 
        onSearch(values) 
      }
    })
  };

  return (
    <div className="searchTitle">
      <Row>
        <Col span={20}>
          <Form layout="inline"  >
            <Form.Item>
              {form.getFieldDecorator(
                "companyName",
                {}
              )(
                <Input
                  style={{ width: 180 }}
                  placeholder="运营商"
                  allowClear
                />
              )}
            </Form.Item>
            <Form.Item>
              <Button type="primary"  onClick={handleSubmit}>
                搜索
              </Button>
            </Form.Item>
          </Form>
        </Col>
        <Col span={4} align="right">
          <Button
            type="primary"
            onClick={onAdd}
          >
            添加运营商
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default Form.create()(Search);
